<template>
  <!-- BEGIN tab -->
  <b-tab @click="tabClick()" class="nav-item-responsice">
    <template slot="title">
      <div class="tab-row">
        <div class="tab-title me-2">{{ title }}</div>
        <div class="tab-number text-right"> <span :class="[badge]">{{ cnt }}</span></div>
      </div>
    </template>
    <!-- BEGIN #accordion -->
    <div class="text-gray-500 mb-3 me-3">{{ subtitle }}</div>
    <div v-if="jobs.filter(item => stats.includes(item.status)).length == 0">
      <div v-if="isLoading">Загружаю... </div>
      <div v-else>Нет данных</div>
    </div>


    <div v-for="(item, index)  in jobs.filter(item => stats.includes(item.status))" :key="index" id="accordion"
      class="accordion rounded-top overflow-hidden">

      <!-- BEGIN b-card -->
      <b-card class="border-0 rounded-0" no-body>
        <b-card-header @click="curr_tab = index" header-tag="header"
          class="card-header pointer-cursor px-3 py-10px d-flex align-items-center" v-b-toggle="'accordion' + index">
          <div class="d-flex">
            <a href="javascript:;" class="w-50px">
              <img onerror="javascript:this.src='/images/avatar/user.png'" :src="`/images/avatar/` + item.user.avatar"
                alt="" width="50" height="50" class="user-avatar">
            </a>
            <div class="flex-1 ps-3">
              <h5 class="user-name pt-2">{{ item.user.name }}</h5>
              <div style="width:45px">
                <Rating :score="item.user.rating" />
              </div>
            </div>
          </div>
        </b-card-header>
        <b-collapse :id="`accordion` + index" visible accordion="my-accordion">
          <div>
            <TaskChat v-if="index == curr_tab" :task="task" :job="item" />
          </div>
        </b-collapse>
      </b-card>
      <!-- END b-card -->
    </div>
    <!-- END #accordion -->
  </b-tab>
  <!-- END tab -->
</template>

<script>


export default {
  name: 'CustomerTab',
  props: ['task', 'jobs', 'cnt', 'title', 'stats', 'badge', 'subtitle'],
  data() {
    return {
      curr_tab: 0,
      isLoading: false
    }
  },
  mounted() {
    window.eventBus.$on('jobshow.loading', (status) => {
      this.isLoading = status;
    })
  },
  methods: {
    tabClick() {
      window.eventBus.$emit('jobshow.update', this.stats[0])
    }
  }

}
</script>


<style>
.user-name:first-letter {
  text-transform: uppercase;
}

.tab-row {
  display: flex;
  flex-direction: row;
}

.tab-number {
  width: unset;
}


@media (max-width: 1150px) {
  .tab-title {
    display: none;
  }
}

@media (max-width: 785px) {
  .tab-number {
    width: unset;
  }
}

.tab-row {
  display: flex;
  justify-content: space-between;
}
</style>